import { kFormatter } from '../../../../utils';
import { calculateOpportunityTdc } from '../../../../utils/opportunity';

function ProjectOverview({ opportunityState }: { opportunityState: any }) {
  const { opportunityInfo, projectUses } = opportunityState;
  // const projectBudget: number =
  //   parseInt(opportunityInfo.projectUses.developmentCost) +
  //   parseInt(opportunityInfo.projectUses.constructionCost) +
  //   parseInt(opportunityInfo.projectUses.financeCost) +
  //   parseInt(opportunityInfo.projectUses.softCost) +
  //   parseInt(opportunityInfo.projectUses.acquisition);
  return (
    <div className='w-full h-auto'>
      <div className='grid text-md gap-4 grid-cols-1 sm:grid-cols-2 mt-4 items-center'>
        <div>
          <div className='flex justify-between items-end mb-2'>
            <div>
              <h2 className='h-2 font-bold text-xl'>{opportunityInfo.projectName}</h2>
              <p className='italic mt-5'>{opportunityInfo.address}</p>
            </div>
            <div className='italic items-end'>Randy Haag</div>
          </div>
          <div className='grid grid-cols-2 lg:grid-cols-3 gap-2 text-md'>
            <div className='rounded-md text-center p-4 bg-white'>
              <div className='text-neutralColor-normal'>Market</div>
              <div className='text-xl font-bold mt-2'>{opportunityInfo.market}</div>
            </div>
            <div className='rounded-md text-center p-4 bg-white'>
              <div className='text-neutralColor-normal'>Sub Market</div>
              <div className='text-xl font-bold mt-2'>{opportunityInfo.subMarket}</div>
            </div>
            <div className='rounded-md text-center p-4 bg-white'>
              <div className='text-neutralColor-normal'>Construction Type</div>
              <div className='text-xl font-bold mt-2'>{opportunityInfo.constructionType}</div>
            </div>
            <div className='bg-white rounded-md text-center py-4 px-4'>
              <div className='text-neutralColor-normal'>Project Type</div>
              <div className='text-xl font-bold mt-2'>{opportunityInfo.projectType ? opportunityInfo.projectType : 'No Value'}</div>
            </div>
            <div className='bg-white rounded-md text-center p-4'>
              <div className='text-neutralColor-normal'>Procurement Type</div>
              <div className='text-xl font-bold mt-2'>{opportunityInfo.procurementType}</div>
            </div>
            <div className='bg-white rounded-md text-center p-4'>
              <div className='text-neutralColor-normal'>Sourcing Document</div>
              <div className='text-xl font-bold mt-2'>{opportunityInfo.constructionType}</div>
            </div>
            <div className='bg-white rounded-md text-center p-4'>
              <div className='text-neutralColor-normal'>Development Partner</div>
              <div className='text-xl font-bold mt-2'>
                {opportunityInfo.developmentPartner ? opportunityInfo.developmentPartner : 'No Value'}
              </div>
            </div>
            <div className='bg-white rounded-md text-center py-4 px-4'>
              <div className='text-neutralColor-normal'>Square Feet</div>
              <div className='text-xl font-bold mt-2'>{opportunityInfo.squareFeet ? opportunityInfo.squareFeet : 'No Value'} Sq.Ft</div>
            </div>
            <div className='bg-white rounded-md text-center py-4 px-4'>
              <div className='text-neutralColor-normal'>TDC</div>
              <div className='text-2xl font-bold mt-2'>${kFormatter(calculateOpportunityTdc(projectUses).toString())}</div>
            </div>
          </div>
        </div>

        <div className='text-right'>
          <div className='italic text-sm mb-2'>Modified: 03/25/2021, 11:52 AM, Aaron Beth</div>
          <div className='border-2 p-2'>
            <img src='https://i.stack.imgur.com/HILmr.png' className='object-contain' />
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProjectOverview;
